<script lang="ts">
    import { defineCustomElement as advCookie } from '@didi/adv-ui/adv-cookie-notice';
    import { onMount } from 'svelte';

    import { cookieHeight, isCookiesShow } from '../store/index';

    export let id = 'CookieConsent';
    export let width = '450';
    export let opacity = '0.9';
    export let bid = 'creditcard';

    let cookieElement: HTMLElement;

    onMount(() => {
        advCookie();
    });

    const handleShowCookieState = (event: CustomEvent) => {
        isCookiesShow.set(event.detail);

        if (!event.detail) {
            cookieHeight.set(0);
        }
    };

    const handleCookieHeight = (event: CustomEvent) => {
        cookieHeight.set(event.detail);
    };

</script>

<adv-cookie-notice
    bind:this={cookieElement}
    {id}
    {width}
    {opacity}
    {bid}
    on:showCookieState={handleShowCookieState}
    on:cookieConsentHeight={handleCookieHeight}
></adv-cookie-notice>
